import * as React from 'react';

import { Link } from '@cian/ui-kit';
import { PictogramProductMagazine40 } from '@cian/ui-kit-design-tokens/pictograms';

import * as flightStyles from './QuestionsAndAnswersItemFlight.css';
import { NBSP } from '../../../constants/symbols';

const NEWBUILDING_GUIDE_LINK = 'https://promo.cian.site/novostrojki_guide';

export const NewbuildingGuideItem = ({ onLinkClick }: { onLinkClick: () => void }): React.JSX.Element => {
  return (
    <div className={flightStyles['item']}>
      <div className={flightStyles['icon']}>
        <PictogramProductMagazine40 color="icon-primary-default" />
      </div>
      <div className={flightStyles['content']}>
        <div className={flightStyles['question']}>
          Хочу побольше вникнуть в{NBSP}тему до{NBSP}того, как{NBSP}оставить заявку. Поможете?
        </div>
        <div className={flightStyles['answer']}>
          Конечно! Наши консультации бесплатны, но понимаем желание разобраться самостоятельно. Специально для{NBSP}
          таких случаев{NBSP}собрали{' '}
          <Link target="_blank" inline href={NEWBUILDING_GUIDE_LINK} onClick={onLinkClick}>
            гайд
          </Link>{' '}
          — в{NBSP}нём всё, что{NBSP}важно знать перед{NBSP}покупкой новостройки.
        </div>
      </div>
    </div>
  );
};
